var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container my-6"},[_c('div',{staticClass:"content has-text-centered has-text-grey"},[_c('p',{staticClass:"is-size-7"},[_c('span',[_vm._v("© "+_vm._s(_vm.year)+" Ikyu Corporation.")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }